(() => {
  if (customElements.get('alva-mobile-search')) return;
  class AlvaMobileSearch extends HTMLElement {
    connectedCallback() {
      if (this.listeners) return;
      this.input = this.querySelector('input[name="q"]');
      this.results = this.querySelector('[role="region"]');
      this.suggestions = this.querySelector('.alva-mobile-nav__search-suggestions');
      if (!this.input || !this.results) return;
      this.listeners = new AbortController();
      this.version = 0;
      const options = { signal: this.listeners.signal };
      this.addEventListener('focusin', () => {
        if (this.suggestions) this.suggestions.hidden = Boolean(this.input.value.trim());
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.dismiss();
      }, options);
      this.addEventListener('click', event => {
        const shortcut = event.target.closest('[data-mobile-search-term]');
        if (!shortcut || !this.contains(shortcut)) return;
        event.preventDefault();
        this.input.value = shortcut.dataset.mobileSearchTerm;
        this.input.focus();
        this.schedule();
      }, options);
      this.input.addEventListener('input', () => this.schedule(), options);
      this.input.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' && !this.results.hidden) {
          const first = this.results.querySelector('a');
          if (first) { event.preventDefault(); first.focus(); }
        }
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && (!this.results.hidden || (this.suggestions && !this.suggestions.hidden))) {
          event.preventDefault(); event.stopPropagation();
          this.input.focus(); this.dismiss();
        }
      }, options);
      this.querySelector('form').addEventListener('submit', event => {
        if (!this.input.value.trim()) event.preventDefault();
      }, options);
      this.closest('header-sidebar')?.addEventListener('dialog:after-hide', () => this.dismiss(), options);
    }
    disconnectedCallback() {
      this.dismiss(); this.listeners?.abort(); this.listeners = null;
    }
    dismiss() {
      clearTimeout(this.timer); this.request?.abort(); this.version++;
      if (!this.results) return;
      this.results.hidden = true;
      this.results.removeAttribute('aria-busy');
      this.input.setAttribute('aria-expanded', 'false');
      if (this.suggestions) this.suggestions.hidden = true;
    }
    schedule() {
      this.dismiss();
      const query = this.input.value.trim();
      if (!query && this.suggestions && document.activeElement === this.input) this.suggestions.hidden = false;
      if (query.length < 2) return;
      const version = this.version;
      this.timer = setTimeout(() => this.search(query, version), 250);
    }
    async search(query, version) {
      this.request = new AbortController();
      const url = new URL(this.dataset.searchUrl, location.origin);
      url.search = new URLSearchParams({ q: query, section_id: 'alva-mobile-predictive-search', 'resources[type]': 'product', 'resources[limit]': '4' });
      this.results.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, { signal: this.request.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const html = await response.text();
        if (version !== this.version || query !== this.input.value.trim()) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('[data-mobile-search-content]');
        if (!content) throw new Error('Search results unavailable');
        this.results.replaceChildren(...document.importNode(content, true).childNodes);
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      } catch (error) {
        if (version === this.version && error.name !== 'AbortError') this.dismiss();
      } finally {
        if (version === this.version) this.results.removeAttribute('aria-busy');
      }
    }
  }
  customElements.define('alva-mobile-search', AlvaMobileSearch);
})();

